'use strict';
import {ManageAccessDirective} from './ManageAccessDirective';
import {ManageAccessModalController} from './ManageAccessModalController';
const angular = require('angular');

module.exports = angular
  .module('app.components.', [])
  .directive('manageAccess', ManageAccessDirective)
  .controller('ManageAccessModalController', ManageAccessModalController)
;



// WEBPACK FOOTER //
// ./src/js/core-components/manage-access/index.js